/* UPSPLUSBATTERY - runtime calculator: Add to cart on in-stock result cards.
   The calculator (assets/upsb-ups-wizard.js) draws its cards from a static index
   that carries no variant ids, so the variant is looked up from /products/<handle>.js
   when the button is pressed. Cards that point to the quote page get no button, and
   quote-only products (tag quote-only, or $10,000 and up) open their product page. */
(function(){
  'use strict';
  /* The French page can swap the calculator in after load (FR cache recovery), so
     nothing here holds on to the first [data-upsb-rtc] element. */
  if (!document.querySelector('[data-upsb-rtc]')) return;
  var lang = (document.documentElement.getAttribute('lang') || '').toLowerCase();
  var path = location.pathname;
  var fr = lang.indexOf('fr') === 0 || path === '/fr' || path.indexOf('/fr/') === 0;
  var T = fr
    ? {add: 'Ajouter au panier', adding: 'Ajout en cours', added: 'Ajouté. Voir le panier', fail: 'Réessayer', cart: '/fr/cart'}
    : {add: 'Add to cart', adding: 'Adding', added: 'Added. View cart', fail: 'Try again', cart: '/cart'};
  var QUOTE_CENTS = 1000000;

  function enhance(wrap){
    if (wrap.querySelector('.upsb-rtc__card-buy')) return;
    var card = wrap.querySelector('a.upsb-rtc__card');
    var sel = wrap.querySelector('[data-upsb-build]');
    if (!card || !sel) return;
    var href = card.getAttribute('href') || '';
    if (href.indexOf('/products/') === -1) return;
    var handle = sel.getAttribute('data-upsb-build');
    if (!handle) return;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'upsb-rtc__card-buy upsb-btn upsb-btn--dark';
    btn.setAttribute('aria-live', 'polite');
    btn.style.cssText = 'width:100%;margin-top:0.6rem;justify-content:center';
    btn.textContent = T.add;
    btn.addEventListener('click', function(){
      if (btn.getAttribute('data-state') === 'added'){ location.href = T.cart; return; }
      btn.disabled = true;
      btn.textContent = T.adding;
      fetch('/products/' + encodeURIComponent(handle) + '.js')
        .then(function(r){ if (!r.ok) throw new Error('product'); return r.json(); })
        .then(function(p){
          var tags = (p.tags || []).map(function(x){ return String(x).toLowerCase(); });
          if (tags.indexOf('quote-only') !== -1 || Number(p.price) >= QUOTE_CENTS){
            location.href = href;
            return null;
          }
          var v = (p.variants || []).filter(function(x){ return x.available; })[0];
          if (!v) throw new Error('variant');
          return fetch('/cart/add.js', {method: 'POST', headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({items: [{id: v.id, quantity: 1}]})});
        })
        .then(function(r){
          if (r === null) return;
          if (!r.ok) throw new Error('cart');
          btn.setAttribute('data-state', 'added');
          btn.textContent = T.added;
          document.dispatchEvent(new CustomEvent('upsb:calc-add', {detail: {handle: handle}}));
        })
        .catch(function(){ btn.textContent = T.fail; })
        .then(function(){ btn.disabled = false; });
    });
    wrap.appendChild(btn);
  }

  function scan(){ document.querySelectorAll('[data-upsb-rtc] .upsb-rtc__card-wrap').forEach(enhance); }
  if (window.MutationObserver) new MutationObserver(scan).observe(document.body, {childList: true, subtree: true});
  scan();
})();